import * as exports from '../export';
import defineModules from './defineModules.macro';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const selfName = require('../../package.json').name;
window.define(selfName, () => exports);

defineModules();
